.committee_session_status {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
